import { render, staticRenderFns } from "./SolRecepcao.vue?vue&type=template&id=13b00086&scoped=true&"
import script from "./SolRecepcao.vue?vue&type=script&lang=js&"
export * from "./SolRecepcao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13b00086",
  null
  
)

export default component.exports